import { Store } from 'src/store';

const getCustomerActionsChain = (store: Store) => store.app.customerActionsChain;

export default getCustomerActionsChain;
